import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'

const TOCContext = createContext({})

export const TOCContextProvider = ({ children }) => {
   const [tocIsOpen, setTocIsOpen] = useState(false)

   const contextValue = {
      tocIsOpen,
      setTocIsOpen
   }

   return (
      <TOCContext.Provider value={contextValue}>
         {children}
      </TOCContext.Provider>
   )
}

TOCContextProvider.propTypes = {
   children: PropTypes.node.isRequired
}

export default TOCContext
